import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=61296303&scoped=true&"
import script from "./CurrencyInput.vue?vue&type=script&lang=js&"
export * from "./CurrencyInput.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyInput.vue?vue&type=style&index=0&id=61296303&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61296303",
  null
  
)

export default component.exports